export class OAuthUserCanceledError extends Error {
  constructor() {
    super();
    this.name = 'OAuthUserCanceledError';
    this.message = 'The user canceled the OAuth flow.';
  }
}
